import api from './axios';

// ========== MIKROTIKS ==========
export const getMikrotiks = (params) => api.get('/mikrotiks', { params });
export const getMikrotik = (id) => api.get(`/mikrotiks/${id}`);
export const createMikrotik = (data) => api.post('/mikrotiks', data);
export const updateMikrotik = (id, data) => api.put(`/mikrotiks/${id}`, data);
export const deleteMikrotik = (id) => api.delete(`/mikrotiks/${id}`);
export const testMikrotikConnection = (id) => api.post(`/mikrotiks/${id}/test-connection`);

// ========== SUCURSAL PARA MIKROTIK ==========
export const listarMikrotiksConSucursal = () => api.get('/mikrotiks/con-sucursal');
export const asignarSucursalMikrotik = (id, sucursalId) => api.put(`/mikrotiks/${id}/sucursal`, { sucursal_id: sucursalId });

// ========== POOLS IP ==========
export const getPools = (params) => api.get('/pools', { params });
export const getPool = (id) => api.get(`/pools/${id}`);
export const createPool = (data) => api.post('/pools', data);
export const updatePool = (id, data) => api.put(`/pools/${id}`, data);
export const deletePool = (id) => api.delete(`/pools/${id}`);

// ========== ADDRESS LISTS ==========
export const getAddressLists = (mikrotikId) => api.get(`/mikrotiks/${mikrotikId}/address-lists`);

export const getAddressListEntries = (mikrotikId, listName) => 
    api.get(`/mikrotiks/${mikrotikId}/address-lists/${encodeURIComponent(listName)}`);

export const addAddressToList = (mikrotikId, listName, data) => 
    api.post(`/mikrotiks/${mikrotikId}/address-lists/${encodeURIComponent(listName)}/addresses`, data);

export const removeAddressFromList = (mikrotikId, listName, address) => 
    api.delete(`/mikrotiks/${mikrotikId}/address-lists/${encodeURIComponent(listName)}/addresses/${encodeURIComponent(address)}`);

export const deleteAddressList = (mikrotikId, listName) => 
    api.delete(`/mikrotiks/${mikrotikId}/address-lists/${encodeURIComponent(listName)}`);

export const printAddressList = (mikrotikId, listName) => 
    api.get(`/mikrotiks/${mikrotikId}/address-lists/${encodeURIComponent(listName)}/print`);
// ========== CLIENT IP ASSIGNMENT ==========
export const getClientIPs = (params) => api.get('/mikrotik/client-ip', { params });
export const getClienteIP = (clienteId) => api.get(`/mikrotik/client-ip/${clienteId}`);
export const assignIPToClient = (data) => api.post('/mikrotik/client-ip', data);
export const updateClientIP = (clienteId, data) => api.put(`/mikrotik/client-ip/${clienteId}`, data);
export const removeClientIP = (clienteId) => api.delete(`/mikrotik/client-ip/${clienteId}`);
